import { useQuery } from '@tanstack/react-query';
import { fetchAgreementInvoices } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

/** Own query key from the sold-items query, so a slow invoices fetch never
 *  blanks the sold-lines tables. */
export function useAgreementInvoicesQuery(agreementId: string | undefined, enabled: boolean) {
    return useQuery({
        queryKey: agreementKeys.invoices(agreementId ?? ''),
        queryFn: () => fetchAgreementInvoices(agreementId!),
        enabled: !!agreementId && enabled,
    });
}
